module.exports = __webpack_public_path__ + "img/hr-sand-rock-big-06.bfb0a82a.png";